import { Button } from "./Button";

export default function CommonButton({ children, ...props }: any) {
  return <Button {...props}>{children}</Button>;
}
